import React from 'react';

function TimeIcon({ bucket }) {
  const common = 'w-5 h-5';
  switch (bucket) {
    case 'one_to_three':
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l3 3" />
        </svg>
      );
    case 'four_to_six':
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6" />
          <path d="M12 12l4 2" />
        </svg>
      );
    case 'seven_plus':
    default:
      return (
        <svg className={common} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6" />
          <path d="M12 12l5 3" />
        </svg>
      );
  }
}

const OPTIONS = [
  { key: 'one_to_three', label: '1–3 years' },
  { key: 'four_to_six', label: '4–6 years' },
  { key: 'seven_plus', label: '7+ years' },
];

export default function ConsultantRetirementTimelineQuestion({ value, onChange, onSubmit }) {
  return (
    <div className="w-full max-w-3xl mx-auto text-succession-text-primary">
      <div className="text-center mb-10">
        <h2 className="text-2xl font-semibold text-succession-text-primary mb-2">When do you plan on exiting?</h2>
        <p className="text-succession-text-secondary text-base">Choose the best timeline</p>
      </div>

      <div className="space-y-3">
        {OPTIONS.map(opt => {
          const selected = value === opt.key;
          return (
            <div
              key={opt.key}
              onClick={() => onChange(opt.key)}
              className={`relative p-5 rounded-xl border cursor-pointer transition-all duration-200 group
                ${selected ? 'border-succession-primary bg-succession-bg-secondary shadow-succession-md' : 'border-succession-border bg-succession-bg-primary hover:border-succession-border-hover hover:shadow-succession-md'}`}
            >
              <div className="flex items-center gap-4">
                <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center transition-colors
                  ${selected ? 'bg-succession-primary/10 text-succession-primary' : 'bg-succession-bg-secondary text-succession-text-secondary group-hover:bg-succession-hover-bg'}`}>
                  <TimeIcon bucket={opt.key} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-base mb-1 text-succession-text-primary">{opt.label}</h3>
                  <p className={`text-sm ${selected ? 'text-succession-text-secondary' : 'text-succession-text-secondary'}`}>We'll personalize next steps</p>
                </div>
                <div className={`flex-shrink-0 w-5 h-5 rounded-full border-2 transition-all duration-200 mt-0.5 ${selected ? 'border-succession-primary bg-succession-primary' : 'border-succession-border group-hover:border-succession-border-hover'}`}></div>
              </div>
              {selected && (
                <>
                  <div className="absolute inset-0 rounded-xl ring-2 ring-succession-primary pointer-events-none" />
                </>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-6 flex justify-end">
        <button
          disabled={!value}
          onClick={onSubmit}
          className="px-4 py-2 rounded-md bg-succession-primary text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-succession-primary-hover"
        >
          Continue
        </button>
      </div>
    </div>
  );
}

